import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import "./index.scss";
import UserTaskCardView, {
  IUserTaskCardViewProps,
} from "../../common_components/user-task-card-view/component";
import MdaeTabPanel from "../../common_components/common_widgets/tab-panel";
import { Item } from "devextreme-react/tab-panel";
import UserTaskList from "../../common_components/user-task-list/component";
import { useDispatch, useSelector } from "react-redux";
import { actions as asyncActions } from "async-ops";
import { GET_COMPLETED_AND_CANCELED_MY_TASKS } from "./services/get-completed-and-canceled-my-tasks";
import MdaeCheckBox from "../../common_components/common_widgets/check-box";
import MdaeNumericBox from "../../common_components/common_widgets/numeric-box";
import {
  defaultCompletedAndCanceledTabData,
  SET_MY_TASKS_COMPLETED_AND_CANCELED_TAB_DATA,
  SET_SELECTED_MY_TASKS_TAB_DATA,
} from "./reducers/my-tasks-page-reducer";
import MdaeButton from "../../common_components/common_widgets/button";
import MdaeTextBox from "../../common_components/common_widgets/text-box";
import {
  CHECK_COMPLETED_OR_CANCELED_CHECKBOX_MESSAGE,
  MY_TASKS_STORAGE_KEYS,
  MY_TASK_PAGE_DATAGRID_STATE_STORAGE_KEYS,
  MY_TASK_PAGE_TABS,
  MY_TASK_STATE_STORAGE_KEY,
  NO_CANCELED_TASKS_MESSAGE,
  NO_COMPLETED_OR_CANCELED_TASKS_MESSAGE,
  NO_COMPLETED_TASKS_MESSAGE,
  NO_TASKS_MESSAGE_FOR_EXTERNAL_USER,
  NO_TASKS_MESSAGE_FOR_NORMAL_USER,
} from "./constant";
import MdaeSwitch from "../../common_components/common_widgets/switch";
import { GET_AUDITOR_LIST } from "../../common_components/user-task-list/services/get-auditor-list";
import { GET_USER_TASK_STATUS_LIST } from "../../common_components/user-task-list/services/get-user-task-status-list";
import { checkListIsEqual } from "../../common_components/mdae-framework";
import { getFormatedDate } from "../../common_components/user-task-card-view/user-task-utils";
import { GET_MY_TASK_LIST } from "../../common_components/user-task-card-view/services/get-my-task-list";
import AddUserTaskPopup from "../../common_components/user-task-list/add-user-task";
import { setIsGridSettingCalled } from "../../common_components/user-task-list/component";
import {
  SET_CURRENT_USER_ACTION_MODE,
  TOGGLE_ADD_USER_TASK_POPUP,
  TOGGLE_COMPLETE_TASK_TOAST,
  defaultUserTaskFormData,
} from "../../common_components/user-task-list/reducers/user-task-list-reducer";
import { GET_ATTACHMENT_LEVEL_LIST } from "../../common_components/user-task-list/services/get-attachment-level-list";
import { isEqual } from "lodash";
import { GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP } from "../user-management/external-users/services/get-active-external-user-list-for-user-group";
import NoTasksAssignedComponent from "./no-tasks-assigned-ui";
import {
  FG_EXTERNAL_USER_TASK_EDITING,
  hasAnyFeatureGroupAccess,
} from "../../common_components/user-permissions-helper";
import { TOGGLE_COMPLETE_TASK_TOAST_FOR_CARD_VIEW } from "../../common_components/user-task-card-view/reducers/user-task-card-view-reducer";
import { GET_EXTERNAL_USER_GROUP_LIST } from "../user-management/external-users/services/get-external-user-group-list";
import { GET_TASK_GROUP_LIST } from "../user-management/task-groups/services/get-task-group-list";
import CaseDetail from "../external-audit/case-detail";
import Guid from "devextreme/core/guid";
interface IMyTasksProps extends IUserTaskCardViewProps {}
export const getLocalStorageValueOrDefault = (
  storageKey: string,
  defaultValue: any
) => {
  const localStorageItem = localStorage.getItem(storageKey);
  if (localStorageItem === null) return defaultValue;
  else return JSON.parse(localStorageItem);
};
const getMytasksDataFromLocalStorageOrDefault = () => {
  const myTasksData = {
    isIncludeCanceledTasks: getLocalStorageValueOrDefault(
      MY_TASKS_STORAGE_KEYS.IS_INCLUDE_CANCELED_TASKS,
      defaultCompletedAndCanceledTabData.isIncludeCanceledTasks
    ),
    canceledTaskMonthRange: getLocalStorageValueOrDefault(
      MY_TASKS_STORAGE_KEYS.CANCELED_TASKS_MONTH_RANGE,
      defaultCompletedAndCanceledTabData.canceledTaskMonthRange
    ),
    isIncludeCompletedTasks: getLocalStorageValueOrDefault(
      MY_TASKS_STORAGE_KEYS.IS_INCLUDE_COMPLETED_TASKS,
      defaultCompletedAndCanceledTabData.isIncludeCompletedTasks
    ),
    completedTaskMonthRange: getLocalStorageValueOrDefault(
      MY_TASKS_STORAGE_KEYS.COMPLETED_TAKS_MONTH_RANGE,
      defaultCompletedAndCanceledTabData.completedTaskMonthRange
    ),
  };
  return myTasksData;
};
interface ICompletedAndCanceledTaskTabProps {
  refreshCompletedAndCanceledTask: () => void;
  isExternalUser: boolean;
}
const CompletedAndCanceledTaskTab: React.FC<ICompletedAndCanceledTaskTabProps> = (
  props
) => {
  const dispatch = useDispatch();
  const [myTaskDataGridSearchText, setMyTaskDataGridSearchText] = useState(
    getLocalStorageValueOrDefault(
      MY_TASK_PAGE_DATAGRID_STATE_STORAGE_KEYS.COMPLETED_AND_CANCELED_TASKS_TAB,
      { searchText: "" }
    )?.searchText
  );
  const isCompletedAndCanceledTaksTabSelcted = useSelector(
    (state: any) =>
      state.myTasksPageReducer.isCompletedAndCanceledTaksTabSelcted,
    isEqual
  );
  const completedAndCanceledTaskList = useSelector(
    (state: any) => state.myTasksPageReducer.completedAndCanceledTaskList,
    checkListIsEqual
  );
  const isCompletedAndCanceledTasksListLoading = useSelector(
    (state) =>
      state["myTasksPageReducer"].isCompletedAndCanceledTasksListLoading
  );
  const isActiveTaksTabSelcted = useSelector(
    (state: any) => state.myTasksPageReducer.isActiveTaksTabSelcted,
    isEqual
  );

  useEffect(() => {
    props.refreshCompletedAndCanceledTask();
  }, []);
  useEffect(() => {
    dispatch({
      type: SET_MY_TASKS_COMPLETED_AND_CANCELED_TAB_DATA,
      data: {
        completedAndCanceledTabData: getMytasksDataFromLocalStorageOrDefault(),
      },
    });
  });
  const isCompletedChecked = useSelector(
    (state) =>
      state["myTasksPageReducer"].completedAndCanceledTabData
        ?.isCompletedChecked,
    isEqual
  );
  const isCanceledChecked = useSelector(
    (state) =>
      state["myTasksPageReducer"].completedAndCanceledTabData
        ?.isCanceledChecked,
    isEqual
  );
  const completedTaskUpdaterConfig = useMemo(() => [
    {
      actionType: SET_MY_TASKS_COMPLETED_AND_CANCELED_TAB_DATA,
      reducerName: "myTasksPageReducer",
      widgetOptionBindings: {
        value: "completedAndCanceledTabData.isIncludeCompletedTasks",
      },
    },
  ], []);
  const completedTaskMonthUpdaterConfig = useMemo(() => [
    {
      actionType: SET_MY_TASKS_COMPLETED_AND_CANCELED_TAB_DATA,
      reducerName: "myTasksPageReducer",
      widgetOptionBindings: {
        value: "completedAndCanceledTabData.completedTaskMonthRange",
      },
    },
  ], []);
  const canceledTaskUpdaterConfig = useMemo(() => [
    {
      actionType: SET_MY_TASKS_COMPLETED_AND_CANCELED_TAB_DATA,
      reducerName: "myTasksPageReducer",
      widgetOptionBindings: {
        value: "completedAndCanceledTabData.isIncludeCanceledTasks",
      },
    },
  ], []);
  const canceledTaskMonthUpdaterConfig = useMemo(() => [
    {
      actionType: SET_MY_TASKS_COMPLETED_AND_CANCELED_TAB_DATA,
      reducerName: "myTasksPageReducer",
      widgetOptionBindings: {
        value: "completedAndCanceledTabData.canceledTaskMonthRange",
      },
    },
  ], []);
  return isCompletedAndCanceledTaksTabSelcted ? (
    <>
      <TaskFilter
        refreshCompletedAndCanceledTask={props.refreshCompletedAndCanceledTask}
        STORAGE_KEYS={MY_TASKS_STORAGE_KEYS}
        myTaskDataGridSearchText={myTaskDataGridSearchText}
        setMyTaskDataGridSearchText={setMyTaskDataGridSearchText}
        completedTaskUpdaterConfig={completedTaskUpdaterConfig}
        completedTaskMonthUpdaterConfig={completedTaskMonthUpdaterConfig}
        canceledTaskUpdaterConfig={canceledTaskUpdaterConfig}
        canceledTaskMonthUpdaterConfig={canceledTaskMonthUpdaterConfig}
        isShowSearchBar={true}
      />
      {completedAndCanceledTaskList?.length > 0 && !isActiveTaksTabSelcted ? ( // while switching tab from completed to active usertasklist was getting rendered again for completed tab causing issue with cache.
        <>
          <UserTaskList
            isUserTaskBulkOptionVisible={true}
            doNotLoadDatasourcesInd={true}
            excelExportFileName="Completed and Canceled Tasks"
            isFromMyTaskPage={true}
            searchText={myTaskDataGridSearchText}
            userTaskListDataSource={completedAndCanceledTaskList}
            setSearchText={setMyTaskDataGridSearchText}
            refreshUserTaskListFunction={props.refreshCompletedAndCanceledTask}
            userTaskListStateStoringKey={
              MY_TASK_PAGE_DATAGRID_STATE_STORAGE_KEYS.COMPLETED_AND_CANCELED_TASKS_TAB
            }
            myTasksPageOptions={{
              myTasksPageTabName:
                MY_TASK_PAGE_TABS.COMPLETED_AND_CANCELED_TASKS_TAB,
            }}
            isExternalUser={props.isExternalUser}
          ></UserTaskList>
        </>
      ) : (
        <>
          {!isCompletedAndCanceledTasksListLoading && (
            <NoTasksAssignedComponent
              message={getNotasksMessageForCompCancTasksTab(
                isCompletedChecked,
                isCanceledChecked,
              )}
            />
          )}
        </>
      )}
    </>
  ) : null;
};
const getNotasksMessageForCompCancTasksTab = (
  isCompletedChecked: boolean,
  isCanceledCheck: boolean
) => {
  if (isCompletedChecked && isCanceledCheck)
    return NO_COMPLETED_OR_CANCELED_TASKS_MESSAGE;
  else if (isCompletedChecked) return NO_COMPLETED_TASKS_MESSAGE;
  else if (isCanceledCheck) return NO_CANCELED_TASKS_MESSAGE;
  else return CHECK_COMPLETED_OR_CANCELED_CHECKBOX_MESSAGE;
};
const getNotasksMessageForActiveTasksTab = (isExternalUser: boolean) => {
  if (isExternalUser) return NO_TASKS_MESSAGE_FOR_EXTERNAL_USER;
  else return NO_TASKS_MESSAGE_FOR_NORMAL_USER;
};
interface IActiveTasksTabProps extends IUserTaskCardViewProps {
  refreshActiveTasks: () => void;
  isExternalUser: boolean;
}
const ActiveTasksTab: React.FC<IActiveTasksTabProps> = (props) => {
  const [isListViewVisible, setListViewVisible] = useState(
    getLocalStorageValueOrDefault(
      MY_TASKS_STORAGE_KEYS.IS_ACTIVE_TASK_TAB_IN_LIST_VIEW_MODE,
      false
    )
  );
  const dispatch = useDispatch();
  const isActiveTaksTabSelcted = useSelector(
    (state: any) => state.myTasksPageReducer.isActiveTaksTabSelcted,
    isEqual
  );
  const myTaskListForDataGrid = useSelector(
    (state) => state["myTaskReducer"].myTaskListForDataGrid,
    checkListIsEqual
  );
  const isMyTasksListLoading = useSelector(
    (state) => state["myTaskReducer"].isMyTasksListLoading
  );
  const isCompleteTaskToastVisibleForCardView = useSelector(
    (state: any) =>
      state["myTaskReducer"].isCompleteTaskToastVisibleForCardView,
    isEqual
  );
  const isCompleteTaskToastVisible = useSelector(
    (state: any) => state["userTaskListReducer"].isCompleteTaskToastVisible,
    isEqual
  );
  return (
    isActiveTaksTabSelcted && (
      <>
        {myTaskListForDataGrid?.length > 0 ? (
          <div className="my-active-tasks-tab-container">
            <div className={"my-active-task-list-view-switch-label"}>
              <div style={{ marginRight: "10px", fontWeight: "bold" }}>
                List View:
              </div>
              <div>
                <MdaeSwitch
                  value={isListViewVisible}
                  onValueChanged={(e) => {
                    if (e.event) {
                      if (isCompleteTaskToastVisibleForCardView) {
                        dispatch({
                          type: TOGGLE_COMPLETE_TASK_TOAST_FOR_CARD_VIEW,
                          data: {
                            isCompleteTaskToastVisibleForCardView: false,
                          },
                        });
                      }
                      if (isCompleteTaskToastVisible) {
                        dispatch({
                          type: TOGGLE_COMPLETE_TASK_TOAST,
                          data: {
                            isCompleteTaskToastVisible: false,
                          },
                        });
                      }
                      setListViewVisible(e.value);
                      localStorage.setItem(
                        MY_TASKS_STORAGE_KEYS.IS_ACTIVE_TASK_TAB_IN_LIST_VIEW_MODE,
                        e.value
                      );
                    }
                  }}
                ></MdaeSwitch>
              </div>
            </div>

            {!isListViewVisible && (
              <div>
                <UserTaskCardView
                  isFromMyTaskPage={true}
                  doNotLoadDatasourcesInd={true}
                  myTaskWidgetId={props.myTaskWidgetId}
                  myPastDueTaskDrawerId={props.myPastDueTaskDrawerId}
                  myThisWeekTaskDrawerId={props.myThisWeekTaskDrawerId}
                  myUpcomingTaskDrawerId={props.myUpcomingTaskDrawerId}
                  myCompletedTaskDrawerId={props.myCompletedTaskDrawerId}
                  isExternalUser={props.isExternalUser}
                ></UserTaskCardView>
              </div>
            )}
            {isListViewVisible && (
              <div>
                <UserTaskList
                  isUserTaskBulkOptionVisible={true}
                  doNotLoadDatasourcesInd={true}
                  excelExportFileName="Active Tasks"
                  isFromMyTaskPage={true}
                  userTaskListDataSource={myTaskListForDataGrid}
                  refreshUserTaskListFunction={props.refreshActiveTasks}
                  userTaskListStateStoringKey={
                    MY_TASK_PAGE_DATAGRID_STATE_STORAGE_KEYS.ACTIVE_TASKS_TAB
                  }
                  myTasksPageOptions={{
                    myTasksPageTabName: MY_TASK_PAGE_TABS.ACTIVE_TASKS_TAB,
                  }}
                  isExternalUser={props.isExternalUser}
                ></UserTaskList>
              </div>
            )}
          </div>
        ) : (
          <>
            {!isMyTasksListLoading && (
              <NoTasksAssignedComponent
                message={getNotasksMessageForActiveTasksTab(
                  props.isExternalUser
                )}
              />
            )}
          </>
        )}
      </>
    )
  );
};

interface IMyTasksProps extends IUserTaskCardViewProps {}
const MyTasks: React.FC<IMyTasksProps> = (props) => {
  const dispatch = useDispatch();
  const isActiveTaksTabSelcted = useSelector(
    (state: any) => state.myTasksPageReducer.isActiveTaksTabSelcted
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );
  const isExternalUser = useMemo(
    () =>
      hasAnyFeatureGroupAccess([FG_EXTERNAL_USER_TASK_EDITING], currentUser),
    [currentUser]
  );
  const isCaseDetailPopupVisible = useSelector(
    (state: any) => state["caseDetailReducer"].isCaseDetailPopupVisible,
    isEqual
  );
  const isCaseDataSaved = useSelector(
    (state: any) => state["caseDetailReducer"].isCaseDataSaved,
    isEqual
  );
  const refreshActiveTasks = useCallback(() => {
    dispatch(
      asyncActions.asyncOperationStart(GET_MY_TASK_LIST, {
        clientTodayDate: getFormatedDate(new Date()),
        myTaskWidgetId: props.myTaskWidgetId,
        isForActiveTasksTab: true,
      })
    );
  }, []);
  const refreshCompletedAndCanceledTask = useCallback(() => {
    const myTaskData = getMytasksDataFromLocalStorageOrDefault();
    dispatch(
      asyncActions.asyncOperationStart(
        GET_COMPLETED_AND_CANCELED_MY_TASKS,
        myTaskData
      )
    );
  }, []);
  const toggleUserTaskPopup = useCallback(
    (dispatch, isVisible, title, mode) => {
      dispatch({
        type: TOGGLE_ADD_USER_TASK_POPUP,
        data: {
          userTaskPopupMode: mode,
          userTaskPopupTitle: title,
          isAddUserTaskPopupVisible: isVisible,
          userTaskFormData:{...defaultUserTaskFormData}

        },
      });
    },
    []
  );
  useEffect(() => {
    dispatch(asyncActions.asyncOperationStart(GET_AUDITOR_LIST, {}));
    dispatch(asyncActions.asyncOperationStart(GET_USER_TASK_STATUS_LIST, {}));
    dispatch(asyncActions.asyncOperationStart(GET_ATTACHMENT_LEVEL_LIST, {}));
    refreshActiveTasks();
    dispatch(
      asyncActions.asyncOperationStart(
        GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP,
        {}
      )
    );
    dispatch(
      asyncActions.asyncOperationStart(GET_EXTERNAL_USER_GROUP_LIST, {})
    );
    dispatch(asyncActions.asyncOperationStart(GET_TASK_GROUP_LIST, {}));
  }, []);
  useEffect(() => {
    setIsGridSettingCalled(dispatch, false);
  }, [isActiveTaksTabSelcted]);

  const prevCaseDetailPopupVisibleRef = useRef(isCaseDetailPopupVisible);
  useEffect(() => {
    if (prevCaseDetailPopupVisibleRef.current && !isCaseDetailPopupVisible && isCaseDataSaved) {
      refreshActiveTasks();
      refreshCompletedAndCanceledTask();
    }
    prevCaseDetailPopupVisibleRef.current = isCaseDetailPopupVisible;
  }, [isCaseDetailPopupVisible]);

  return (
    <div className="my-task-page-container">
      {!isCaseDetailPopupVisible && (
        <AddUserTaskPopup
          toggleUserTaskPopup={toggleUserTaskPopup}
          isManagerView={true}
          isFromUserTaskList={true}
          isFromMyTaskPage={true}
          refreshUserTaskListFunction={() => {
            if (isActiveTaksTabSelcted) refreshActiveTasks();
            else refreshCompletedAndCanceledTask();
          }}
          isExternalUser={isExternalUser}
        ></AddUserTaskPopup>
      )}
      <MdaeTabPanel
        onSelectionChanged={(e) => {
          let data = {
            isActiveTaksTabSelcted: false,
            isCompletedAndCanceledTaksTabSelcted: false,
          };
          switch (e.component.option("selectedIndex")) {
            case 0:
              dispatch({
                type: SET_SELECTED_MY_TASKS_TAB_DATA,
                data: {
                  isActiveTaksTabSelcted: true,
                },
              });
              delete data.isActiveTaksTabSelcted;
              break;

            case 1:
              dispatch({
                type: SET_SELECTED_MY_TASKS_TAB_DATA,
                data: {
                  isCompletedAndCanceledTaksTabSelcted: true,
                },
              });
              delete data.isCompletedAndCanceledTaksTabSelcted;
              break;
          }
          setTimeout(() => {
            dispatch({
              type: SET_SELECTED_MY_TASKS_TAB_DATA,
              data,
            });
            dispatch({
              type: SET_CURRENT_USER_ACTION_MODE,
              currentUserActionMode: "",
            });
          });
        }}
      >
        <Item title={"Active Tasks"}>
          <ActiveTasksTab
            {...props}
            refreshActiveTasks={refreshActiveTasks}
            isExternalUser={isExternalUser}
          ></ActiveTasksTab>
        </Item>
        {!isExternalUser && (
          <Item title={"Completed & Canceled Tasks"}>
            <CompletedAndCanceledTaskTab
              refreshCompletedAndCanceledTask={refreshCompletedAndCanceledTask}
              isExternalUser={isExternalUser}
            ></CompletedAndCanceledTaskTab>
          </Item>
        )}
      </MdaeTabPanel>

      {isCaseDetailPopupVisible && (
        <CaseDetail
          eaRoundId={0}
          caseMyTaskWidgetId={new Guid().toString()}
          caseMyPastDueTaskDrawerId={new Guid().toString()}
          caseMyThisWeekTaskDrawerId={new Guid().toString()}
          caseMyUpcomingTaskDrawerId={new Guid().toString()}
          caseMyCompletedTaskDrawerId={new Guid().toString()}
          isViewOnly={false}
          isHideBillingHistoryLink={false}
          isFromDenialPredictor={false}
        />
      )}
    </div>
  );
};

export default MyTasks;

interface TaskFilterProps {
  refreshCompletedAndCanceledTask: () => void;
  STORAGE_KEYS: any;
  completedTaskUpdaterConfig: any[];
  canceledTaskUpdaterConfig: any[];
  completedTaskMonthUpdaterConfig: any[];
  canceledTaskMonthUpdaterConfig: any[];
  myTaskDataGridSearchText?: string;
  setMyTaskDataGridSearchText?: (val: string) => void;
  isShowSearchBar:boolean;
}

export const TaskFilter: React.FC<TaskFilterProps> = (props) => {
  return (
    <div className="tasks-completed-and-canceled-tab-search-container">
      <div>
        <MdaeButton
          id="btnRefreshCompletedAndCanceledTaskPage"
          role="dxButton"
          stylingMode="text"
          className="refresh-task-icon"
          onClick={props.refreshCompletedAndCanceledTask}
        />
      </div>

      <div className="filter-section">
        <div className="tasks-filter-container">
          <MdaeCheckBox
            id="chkMyTaskIncludeCompletedTasks"
            text="Include Completed Tasks from last"
            onValueChanged={(e) => {
              if (e.event) {
                localStorage.setItem(
                  props.STORAGE_KEYS.IS_INCLUDE_COMPLETED_TASKS,
                  e.value
                );
              }
            }}
            mdaeDataUpdaterConfig={props.completedTaskUpdaterConfig}
          />
          <MdaeNumericBox
            id="txtCompletedTaskMonthRange"
            className="middle-input"
            onValueChanged={(e) => {
              if (e.event) {
                localStorage.setItem(
                  props.STORAGE_KEYS.COMPLETED_TAKS_MONTH_RANGE,
                  e.value
                );
              }
            }}
            mdaeDataUpdaterConfig={props.completedTaskMonthUpdaterConfig}
            min={1}
            max={9999}
            format="######"
            width={80}
          />
          <div className="suffix-text">month(s)</div>
        </div>

        <div className="tasks-filter-container">
          <MdaeCheckBox
            id="chkMyTaskIncludeCanceledTasks"
            text="Include Canceled Tasks from last"
            onValueChanged={(e) => {
              if (e.event) {
                localStorage.setItem(
                  props.STORAGE_KEYS.IS_INCLUDE_CANCELED_TASKS,
                  e.value
                );
              }
            }}
            mdaeDataUpdaterConfig={props.canceledTaskUpdaterConfig}
          />
          <MdaeNumericBox
            id="txtCanceledTaskMonthRange"
            className="middle-input canceled-task-month-range"
            style={{ marginLeft: "25px" }}
            onValueChanged={(e) => {
              if (e.event) {
                localStorage.setItem(
                  props.STORAGE_KEYS.CANCELED_TASKS_MONTH_RANGE,
                  e.value
                );
              }
            }}
            mdaeDataUpdaterConfig={props.canceledTaskMonthUpdaterConfig}
            min={1}
            max={9999}
            format="######"
            width={80}
          />
          <div className="suffix-text">month(s)</div>
        </div>
      </div>

      {props.isShowSearchBar && (
        <div className="user-task-search-box-container">
          <MdaeTextBox
            id="txtMyTaskSearch"
            placeholder="Search..."
            valueChangeEvent="keyup"
            value={props.myTaskDataGridSearchText}
            onValueChanged={(e) => props.setMyTaskDataGridSearchText(e.value)}
            onValueChange={(value) => props.setMyTaskDataGridSearchText(value)}
          />
          <div className="dx-icon dx-icon-search user-task-card-datagrid-search-icon application-section-primary-background-color"></div>
        </div>
      )}
    </div>
  );
};
